<template>
  <div class="map-preview">
    <router-link
      class="map-preview__map-link"
      :to="{ name: 'map' }"
      data-cy="map-link"
    >
      <span class="map-preview__map-link-title">
        {{ t('efriends.mapTitle') }}<br />
        {{ t('efriends.mapSubtitle') }}
      </span>
      <img
        class="map-preview__map-img"
        :src="mapPreviewImgUrl"
      />
    </router-link>
  </div>
</template>

<script setup>
  import { useStrings } from '@/composables/useStrings.ts'
  import { computed } from 'vue'
  import { useAppStore } from '@/stores/useAppStore'
  import { storeToRefs } from 'pinia'
  import { useCubeStore } from '@/stores/useCubeStore'

  // Stores
  const { latitude, longitude } = storeToRefs(useCubeStore())
  const { googleMapsApiKey, googleMapsMapIdPreview, googleMapsStaticApiBaseUrl } = storeToRefs(useAppStore())

  const { t } = useStrings()

  const mapPreviewImgUrl = computed(() => {
    const params = {
      center: latitude.value + ',' + longitude.value,
      zoom: 15,
      size: '400x150',
      key: googleMapsApiKey.value,
      map_id: googleMapsMapIdPreview.value,
    }

    let getParameters = Object.entries(params)
      .map((param) => {
        return param[0] + '=' + param[1]
      })
      .join('&')

    return googleMapsStaticApiBaseUrl.value + '?' + getParameters
  })
</script>

<style lang="scss">
  .map-preview {
    text-align: center;

    &__map-img {
      max-width: 100%;
      transition: $transition-base;
      opacity: 0.8;
    }

    &__map-link {
      position: relative;
      display: inline-block;
      cursor: pointer;
      border: 1px solid $grey-lighter;
      border-radius: $border-radius;
      transition: $transition-base;

      @include hover-focus-active {
        .map-preview__map-img {
          opacity: 0.6;
        }
      }

      &-title {
        position: absolute;
        z-index: 1;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: $body-color;
        font-size: $font-size-xl;
        line-height: $line-height-min;
        width: 80%;
        padding: $spacer05 $spacer10;

        @media (min-width: $bp-lg) {
          border-radius: $border-radius;
        }
      }
    }
  }
</style>
